import { formatString } from '@cbgms/base/utils/helpers'
import { AddressTypes, IAddress } from './address'

export const formatAddressCityThenPostalCode = (address: Partial<IAddress>, type: AddressTypes) => {
  if (type === 'Visitor') {
    return formatString(address.VisitorCity, address.VisitorPostalCode)
  }

  return formatString(address.PostalCity, address.PostalPostalCode)
}
